export const appMenu = [
  {
    title: "Рабочий стол",
    icon: "dashboard",
    route: "home",
  },
  {
    title: "Справочники",
    icon: "folder",
    subItems: [
      { title: "Страны", route: "countries" },
      { title: "Регионы", route: "regions" },
      { title: "Области", route: "districts" },
      { title: "Города", route: "cities" },
      {
        title: "Адреса",
        route: "addresses",
      },
      {
        title: "Индексы",
        route: "locations",
        divider: true,
      },
      { title: "Офисы", route: "offices" },
      { title: "Должности", route: "positions" },
      {
        title: "Сотрудники",
        route: "employees",
        divider: true,
      },
      { title: "Клиенты", route: "clients" },
      { title: "Продавцы", route: "factories" },
      { title: "Склады", route: "warehouses" },
      {
        title: "Контактные лица",
        route: "contact-persons",
        divider: true,
      },
      { title: "Типы товара", route: "goods-types" },
      {
        title: "Тарифы",
        route: "tariffs",
        divider: true,
      },
      { title: "Курьерские службы", route: "courier-services" },
      { title: "Перевозчики", route: "carriers" },
      { title: "Машины", route: "vehicles" },
      { title: "Водители", route: "drivers" },
      { title: "Подвижной состав", route: "rolling-stocks" },
      {
        title: "Типы подвижного состава",
        route: "rolling-stock-types",
      },
      { title: "Типы упаковок", route: "package-types", divider: true },
      { title: "Производители", route: "manufacturers" },
      {
        title: "Категории товаров",
        route: "product-categories",
      },
      {
        title: "Единицы измерения веса",
        route: "units",
      },
      {
        title: "Торговые марки",
        route: "trademarks",
      },
      {
        title: "Модели(ТМ)",
        route: "trademark-models",
      },
      {
        title: "Номенклатуры",
        route: "nomenclatures",
      },
      {
        title: "Артикулы",
        route: "articles",
        divider: true,
      },
      {
        title: "Роды деятельности",
        route: "activity-types",
      },
      { title: "Валюты", route: "currencies" },
      { title: "Экспедиторы", route: "forwarders" },
    ],
  },
  {
    title: "Операции",
    icon: "description",
    subItems: [
      {
        title: "Запросы",
        route: "shipment-requests",
      },
      {
        title: "Запросы (черновики)",
        route: "shipment-request-drafts",
      },
      {
        title: "Поставки",
        route: "shippings",
      },
      {
        title: "Поставки (черновики)",
        route: "shipping-drafts",
      },
      { title: "Описание товаров", route: "goods-details-list" },
      { title: "Планирование Маршрутов", route: "routes-planning" },
      { title: "Маршруты", route: "routes" },
      { title: "Затаможка", route: "customs-entry-registrations" },
      { title: "Склады (старая версия)", route: "old-version-warehouse-details" },
      { title: "Склады (в разработке)", route: "warehouse-details" },
      { title: "Отгрузки", route: "release-orders" },
    ],
  },
  {
    title: "Настройки",
    icon: "settings",
    subItems: [
      { title: "Настройки", route: "settings" },
      { title: "Пользователи", icon: "supervisor_account", route: "users" },
      { title: "Параметры доступа", route: "users-permissions" },
    ],
  },
  {
    title: "Импорт",
    icon: "import_export",
    subItems: [
      { title: "Клиенты", route: "import-clients" },
      // { title: "Клиенты(черновики)", route: "/clients-drafts" },
      { title: "Продавцы", route: "import-factories" },
      // { title: "Продавцы(черновики)", route: "/factories-drafts" }
      { title: "База Адресов", route: "import-locations" },
      { title: "Описание товаров", route: "import-goods" },
      { title: "Описание товаров(черновики)", route: "goods-drafts" },
      { title: "Разрешение на отгрузку", route: "import-shipping-release-approvement" },
    ],
  },
  {
    title: "Пользователи Кабинета Клиента",
    icon: "people",
    route: "cabinet-users",
  },
];
